export default {
  __name: 'App',
  setup(__props) {
    return {
      __sfc: true
    };
  }
};